import { render } from "./Calculations.vue?vue&type=template&id=4c856a63&scoped=true"
import script from "./Calculations.vue?vue&type=script&lang=js"
export * from "./Calculations.vue?vue&type=script&lang=js"

import "./Calculations.vue?vue&type=style&index=0&id=4c856a63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c856a63"]])

export default __exports__